/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BasicFile,
    BasicFileFromJSON,
    BasicFileFromJSONTyped,
    BasicFileToJSON,
} from './';

/**
 * 
 * @export
 * @interface FileUpdate
 */
export interface FileUpdate {
    /**
     * 
     * @type {string}
     * @memberof FileUpdate
     */
    name: string;
    /**
     * 
     * @type {Array<BasicFile>}
     * @memberof FileUpdate
     */
    files?: Array<BasicFile> | null;
    /**
     * 
     * @type {string}
     * @memberof FileUpdate
     */
    parent: string;
    /**
     * 
     * @type {string}
     * @memberof FileUpdate
     */
    mode?: string;
    /**
     * 
     * @type {number}
     * @memberof FileUpdate
     */
    uid?: number;
    /**
     * 
     * @type {number}
     * @memberof FileUpdate
     */
    gid?: number;
    /**
     * 
     * @type {string}
     * @memberof FileUpdate
     */
    user?: string;
    /**
     * 
     * @type {string}
     * @memberof FileUpdate
     */
    group?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FileUpdate
     */
    recursive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FileUpdate
     */
    affinity?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FileUpdate
     */
    modeSetuid?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FileUpdate
     */
    modeSetgid?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FileUpdate
     */
    modeSetvfx?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FileUpdate
     */
    modeUserRead?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FileUpdate
     */
    modeUserWrite?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FileUpdate
     */
    modeUserExecute?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FileUpdate
     */
    modeGroupRead?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FileUpdate
     */
    modeGroupWrite?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FileUpdate
     */
    modeGroupExecute?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FileUpdate
     */
    modeOthersRead?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FileUpdate
     */
    modeOthersWrite?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FileUpdate
     */
    modeOthersExecute?: boolean;
}

export function FileUpdateFromJSON(json: any): FileUpdate {
    return FileUpdateFromJSONTyped(json, false);
}

export function FileUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'files': !exists(json, 'files') ? undefined : (json['files'] === null ? null : (json['files'] as Array<any>).map(BasicFileFromJSON)),
        'parent': json['parent'],
        'mode': !exists(json, 'mode') ? undefined : json['mode'],
        'uid': !exists(json, 'uid') ? undefined : json['uid'],
        'gid': !exists(json, 'gid') ? undefined : json['gid'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'group': !exists(json, 'group') ? undefined : json['group'],
        'recursive': !exists(json, 'recursive') ? undefined : json['recursive'],
        'affinity': !exists(json, 'affinity') ? undefined : json['affinity'],
        'modeSetuid': !exists(json, 'mode_setuid') ? undefined : json['mode_setuid'],
        'modeSetgid': !exists(json, 'mode_setgid') ? undefined : json['mode_setgid'],
        'modeSetvfx': !exists(json, 'mode_setvfx') ? undefined : json['mode_setvfx'],
        'modeUserRead': !exists(json, 'mode_user_read') ? undefined : json['mode_user_read'],
        'modeUserWrite': !exists(json, 'mode_user_write') ? undefined : json['mode_user_write'],
        'modeUserExecute': !exists(json, 'mode_user_execute') ? undefined : json['mode_user_execute'],
        'modeGroupRead': !exists(json, 'mode_group_read') ? undefined : json['mode_group_read'],
        'modeGroupWrite': !exists(json, 'mode_group_write') ? undefined : json['mode_group_write'],
        'modeGroupExecute': !exists(json, 'mode_group_execute') ? undefined : json['mode_group_execute'],
        'modeOthersRead': !exists(json, 'mode_others_read') ? undefined : json['mode_others_read'],
        'modeOthersWrite': !exists(json, 'mode_others_write') ? undefined : json['mode_others_write'],
        'modeOthersExecute': !exists(json, 'mode_others_execute') ? undefined : json['mode_others_execute'],
    };
}

export function FileUpdateToJSON(value?: FileUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'files': value.files === undefined ? undefined : (value.files === null ? null : (value.files as Array<any>).map(BasicFileToJSON)),
        'parent': value.parent,
        'mode': value.mode,
        'uid': value.uid,
        'gid': value.gid,
        'user': value.user,
        'group': value.group,
        'recursive': value.recursive,
        'affinity': value.affinity,
        'mode_setuid': value.modeSetuid,
        'mode_setgid': value.modeSetgid,
        'mode_setvfx': value.modeSetvfx,
        'mode_user_read': value.modeUserRead,
        'mode_user_write': value.modeUserWrite,
        'mode_user_execute': value.modeUserExecute,
        'mode_group_read': value.modeGroupRead,
        'mode_group_write': value.modeGroupWrite,
        'mode_group_execute': value.modeGroupExecute,
        'mode_others_read': value.modeOthersRead,
        'mode_others_write': value.modeOthersWrite,
        'mode_others_execute': value.modeOthersExecute,
    };
}


